import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { BlockUnsavedForm } from "../BlockUnsavedForm/BlockUnsavedForm";
import { FormActionButtons } from "../FormActionButtons/FormActionButtons";
import { unblockRoute } from "../../Services/BlockChangeRoute";
import * as PropertyBucket from '../../Properties/Properties.js';
import Input from '../Input/Input';

export const FormSchema = Yup.object().shape({
  name: Yup.string()
    .min(1)
    .max(500, "Blok może mieć maksymalnie 500 znaków")
    .required(PropertyBucket.getBlockNameMustBeChosen()),
});

export const BlockForm = (props) => {
  const [isControlsDisabled, setControlsDisabled] = useState(false);
  const [violations, setViolations] = useState(null);

  useEffect (() => {
    const violationsList = props.violations.length > 0 ? props.violations?.map(v => v.violation + '. ') : null;
    setViolations(violationsList);
  }, [props.violations]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        code: props.code ? props.code : "",
        name: props.name ? props.name : "",
      }}
      validationSchema={FormSchema}
      onSubmit={(values, { resetForm }) => {
        unblockRoute();
        props.handleSaveBlock({ values, resetForm });
        setControlsDisabled(true);
      }}
    >
      {({ values, errors, setFieldValue }) => {
        return (
          <>
            <BlockUnsavedForm />
            <Form
              onChange={() => {
                isControlsDisabled && setControlsDisabled(false); 
                setViolations(null);
              }}
            >
              <div className='row'>
                <div className='col-md-2'>
                  <Input
                    disabled={true}
                    name='code'
                    inputId='block-code'
                    className='form-control'
                    label='Kod bloku'
                    formik
                  />
                </div>
                <div className='col-md-10'>
                  <Input
                    formik
                    name='name'
                    inputId='name'
                    className='form-control'
                    label='Tytuł bloku'
                    onChange={(e) => setFieldValue("name", e.target.value)}
                    chartsCount={values.name.length}
                    errorId='blockNameAlert'
                    error={errors.name && errors.name || violations}
                    maxLength={500}
                    invalid={errors.name || violations}
                  />
                </div>
              </div>
              <FormActionButtons
                abortPath='/search_block'
                disabled={isControlsDisabled}
                context='blok'
              />
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

BlockForm.propTypes = {
  code: PropTypes.number,
  name: PropTypes.string,
};
